import { Directive, Input, signal } from '@angular/core';
import { TicketStatus } from '../../models';

type ClassAndText = {
  class: string;
  text: string;
};

const BASE_CLASSES = 'nav-text p-x-10 p-y-2 text-uppercase border-radius-small';

// The status classes carry the text colour as well, so they must not be stacked.
const StatusClassesAndTextObj: Partial<Record<TicketStatus, ClassAndText>> = {
  [TicketStatus.OPEN]: {
    class: 'color-ticket-status-open',
    text: 'ticket_status.open_l',
  },
  [TicketStatus.IN_PROGRESS]: {
    class: 'color-ticket-status-in-progress',
    text: 'ticket_status.in-progress_l',
  },
  [TicketStatus.WAITING_FOR_OTHERS]: {
    class: 'color-ticket-status-in-progress',
    text: 'ticket_status.waiting-for-others_l',
  },
  [TicketStatus.CLOSED]: {
    class: 'color-ticket-status-closed',
    text: 'ticket_status.closed_l',
  },
  [TicketStatus.CANCELLED]: {
    class: 'color-ticket-status-cancelled',
    text: 'ticket_status.cancelled_l',
  },
};

@Directive()
export abstract class StatusBadgeBaseComponent {
  public className = signal(BASE_CLASSES);
  public text = signal('');
  @Input() set state(status: TicketStatus) {
    this.setClassNameAndText(status);
  }

  private setClassNameAndText(status: TicketStatus) {
    const value = StatusClassesAndTextObj[status];

    // Rebuild from the base classes so a status change swaps the colour class
    // instead of appending a second one on top of the previous status.
    this.className.set(value ? `${BASE_CLASSES} ${value.class}` : BASE_CLASSES);
    this.text.set(value?.text ?? '');
  }
}
